import { render, staticRenderFns } from "./ACT.vue?vue&type=template&id=38ac02e0&scoped=true"
import script from "./ACT.vue?vue&type=script&lang=js"
export * from "./ACT.vue?vue&type=script&lang=js"
import style0 from "./ACT.vue?vue&type=style&index=0&id=38ac02e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac02e0",
  null
  
)

export default component.exports